import Cookie from "../plugins/Cookie";

$(function () {

    $('.city-choose__list-item').click(function () {
        if ($(this).hasClass('city-choose__list-item_active'))
            return;

        const id = $(this).attr('choose-item');

        $.ajax({
            type: 'post',
            url: '/ajax/city/get-new-url/',
            data: {id},
            success: href => {
                window.location.href = href;
            }
        });
    });

    $('[name="city"]').change(function () {

        const val = $(this).val();

        if (val) {
            Cookie.set('city', val, {expires: 60 * 60 * 24 * 7});
        } else {
            Cookie.delete('city');
        }

    });

});